import React, { useState } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import {
  MenuProps,
  useStyles,
} from "./utility";

function SelectMenu(props) {
  const classes = useStyles();
  const { options, handleChange, selectedValue, label } = props;

  return (
    <FormControl className={classes.formControl}>
      <InputLabel
        id="mutiple-select-label"
        style={{
          fontFamily: "GT-Walsheim-medium",
          fontSize: "18px",
          color: "black",
          fontWeight: "bold",
          marginTop: "-5px",
        }}
      >
        {label}
      </InputLabel>
      <Select
        labelId="mutiple-select-label"
        multiple
        value={selectedValue}
        onChange={handleChange}
        renderValue={(selected) => selected.join(", ")}
        MenuProps={MenuProps}
      >
        {options.map((option) => (
          <MenuItem key={option.label} value={option.value}>
            <ListItemIcon>
              <Checkbox
                checked={selectedValue.includes(option.value)}
                style={{
                  color: "#4f2d7f",
                  padding: "0px",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary={option.label}
              style={{ marginLeft: "-20px" }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectMenu;
